import type { DocumentTitleOptions } from '@react-navigation/native';

export const navigationDocumentTitleOptions: DocumentTitleOptions = {
  formatter: (options) => options?.customDocumentTitle ?? 'sweetgreen',
};

// NOTE: refers to the top level (app level) stack navigator
export const APP_STACK_NAVIGATOR_ID = 'app-stack-navigator';
